var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaper(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tablet buttons/Iconly/Bold/Paper"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    d: "M16.5991 8.03253C17.2157 8.03879 18.0728 8.04147 18.7999 8.03879C19.1724 8.03789 19.3617 7.5885 19.1034 7.3178C18.1692 6.33682 16.4983 4.58125 15.5421 3.57705C15.2776 3.29919 14.8149 3.49038 14.8149 3.87545V6.2305C14.8149 7.21863 15.6208 8.03253 16.5991 8.03253Z",
    fill: "url(#paint0_linear_9146_78897)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0656 15.9188H9.25349C8.89081 15.9188 8.59006 15.6151 8.59006 15.2487C8.59006 14.8824 8.89081 14.5876 9.25349 14.5876H14.0656C14.4283 14.5876 14.729 14.8824 14.729 15.2487C14.729 15.6151 14.4283 15.9188 14.0656 15.9188ZM9.25349 10.1233H12.2434C12.606 10.1233 12.9068 10.4271 12.9068 10.7934C12.9068 11.1597 12.606 11.4545 12.2434 11.4545H9.25349C8.89081 11.4545 8.59006 11.1597 8.59006 10.7934C8.59006 10.4271 8.89081 10.1233 9.25349 10.1233ZM19.1963 9.33431C18.816 9.33431 18.3648 9.34324 18.0906 9.34324C17.6837 9.34324 17.153 9.33431 16.4807 9.33431C14.8619 9.32537 13.5262 7.98524 13.5262 6.35029V3.47347C13.5262 3.25012 13.3493 3.0625 13.1193 3.0625H8.39568C6.19309 3.0625 4.40625 4.87614 4.40625 7.09182V16.7229C4.40625 19.0458 6.28155 20.9309 8.58144 20.9309H15.6227C17.8164 20.9309 19.5944 19.1351 19.5944 16.9194V9.73635C19.5944 9.51299 19.4175 9.33431 19.1963 9.33431Z",
    fill: "url(#paint1_linear_9146_78897)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9146_78897",
    x1: 12.4055,
    y1: 4.2576,
    x2: 18.539,
    y2: 9.21535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0144228,
    stopColor: "#BBE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.759615,
    stopColor: "#0C6AEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9146_78897",
    x1: -3.8966,
    y1: 6.22155,
    x2: 19.2008,
    y2: 22.7639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0144228,
    stopColor: "#BBE3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.759615,
    stopColor: "#0C6AEF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaper);
export default __webpack_public_path__ + "static/media/paper.368444e0fddfe0a69926ac3e0054a382.svg";
export { ForwardRef as ReactComponent };